var _path, _path2, _path3, _path4, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgAttackItem(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 576,
    height: 35,
    viewBox: "0 0 576 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.7881 0L9.0596 34.7285H0L34.7285 0",
    fill: "#8DF6F5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.894 0.16777L25.1656 34.8962H16.106L50.8344 0.16777",
    fill: "#8DF6F5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M76 0.167725L41.2715 34.8962H32.2119L66.9404 0.167725",
    fill: "#8DF6F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M575.5 0.167725L540.772 34.8962H41L75.7285 0.167725",
    fill: "url(#paint0_linear_3_22272)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3_22272",
    x1: 19,
    y1: 34.8962,
    x2: 521,
    y2: 34.8962,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8DF6F5",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8DF6F5",
    stopOpacity: 0
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttackItem);
export default __webpack_public_path__ + "static/media/attack-item.b05d325447fc7d5ab31aed1d867139fd.svg";
export { ForwardRef as ReactComponent };